/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_Session_ExpiredInputs */



/**
* | output |
* | --- |
* | "Your session has expired. Please sign in again." |
*
* @param {Auth_Error_Session_ExpiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_session_expired = /** @type {((inputs?: Auth_Error_Session_ExpiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_Session_ExpiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre session a expiré. Veuillez vous reconnecter.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su sesión ha expirado. Por favor, inicie sesión de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sua sessão expirou. Por favor, entre novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La tua sessione è scaduta. Accedi di nuovo.")
	return /** @type {LocalizedString} */ ("Your session has expired. Please sign in again.")
});